import { useEffect, useRef } from "react";
import "./index.scss";
import Typed from "typed.js";
import {
  faLinkedinIn,
  faGithub,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import IntroVideo from "../IntroVideo";

const ROLES = [
  "Senior Flutter Developer.",
  "AI Apps Developer.",
  "Mobile App Developer.",
  "Full-Stack Developer.",
];

const Home = () => {
  const el = useRef(null);

  useEffect(() => {
    // Respect the OS "reduce motion" setting: show the first role without typing
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      el.current.textContent = ROLES[0];
      return;
    }

    const typed = new Typed(el.current, {
      strings: ROLES.map((role) => `${role}\n`),
      typeSpeed: 60,
      fadeOut: true,
      loop: true,
    });

    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <div className="container home-page">
      <div className="text-zone">
      <div className="socials">
          <div className="social">
            <a
              href="mailto:chiragboghara26@gmail.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Email"
            >
              <FontAwesomeIcon icon={faEnvelope} color="white" size="3x" />
            </a>
          </div>
          <div className="social">
            <a
              href="https://www.linkedin.com/in/chirag-boghara/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn (opens in new tab)"
            >
              <FontAwesomeIcon icon={faLinkedinIn} color="#0077B5" size="3x" />
            </a>
          </div>
          <div className="social">
            <a
              href="https://github.com/ChiragBoghara/"
              target="_blank"
              rel="noreferrer"
              aria-label="GitHub (opens in new tab)"
            >
              <FontAwesomeIcon icon={faGithub} color="white" size="3x" />
            </a>
          </div>
          <div className="social">
            <a
              href="https://www.instagram.com/chirag_boghara_/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram (opens in new tab)"
            >
              <FontAwesomeIcon icon={faInstagram} color="#E1306C" size="3x" />
            </a>
          </div>
          <div className="social">
            <a
              href="https://wa.me/919909150454"
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp (opens in new tab)"
            >
              <FontAwesomeIcon icon={faWhatsapp} color="	#25D366" size="3x" />
            </a>
          </div>
        </div>
        <h1>
          <div>Hi !</div>
          <div>I'm Chirag Boghara ✌️,</div>
          {/* Screen readers get the full list instead of half-typed words */}
          <span className="sr-only">{ROLES.join(" ")}</span>
          <span ref={el} aria-hidden="true" />
        </h1>
        <div className="intro">
          <p>
            Senior Flutter Developer from Surat, India, building fast,
            beautiful cross-platform mobile apps for Android and iOS with
            Flutter and Dart. I specialize in AI-powered Flutter apps,
            pixel-perfect Flutter UI, REST API integration and scalable
            backends with Firebase, Supabase and the MERN stack.
          </p>
          <p>
            Available for freelance Flutter app development or Web Development, from MVP to
            Play Store and App Store launch.
          </p>
        </div>
        <IntroVideo />
      </div>
    </div>
  );
};

export default Home;
